// extracted by mini-css-extract-plugin
export default {"wrapper":"Navigation_wrapper__vKHUi","line":"Navigation_line__60SAG","item":"Navigation_item__PQCMi","selected":"Navigation_selected__Umtfc","disabled":"Navigation_disabled__D8yLT"};